<template>
  <div class="body">
    <!-- DATA E UNIDADE -->
    <b-container class="occurrence-config">
      <b-row class="row occurrence-date">
        <b-col sm="4" class="date-item d-flex">
          <label class="mr-3" for="date-picker">{{ $t('data-da-ocorrencia') }}</label>
          <span class="date-item-2">
            <date-picker id="date-picker" class="adjustDatePickers input-pentagro" ref="datePickerStart" name="date"
              v-model="productionDate" :config="optionsDatePicker" @input="validateDate"></date-picker>
            <i class="fa fa-calendar fa-lg ml-2" aria-hidden="true"></i>
          </span>
        </b-col>

        <b-col sm="4" class="date-item d-flex">
          <label for="deadline-picker">{{ $t('deadlineInDays') }}</label>
          <span class="date-item-2">
            <date-picker id="deadline-picker" class="adjustDatePickers input-pentagro" ref="datePickerDeadline" name="deadline"
              v-model="deadlineDate" :config="optionsDeadlinePicker" @input="validateDeadlineDate"></date-picker>
            <i class="fa fa-calendar fa-lg ml-2" aria-hidden="true"></i>
          </span>
        </b-col>

        <b-col sm="4" class="progression-config">
          <label for="progression" :title="$t('quantidade-de-registros-dentro-da-especificacao')">{{ $t('progression') }}</label>
          <input @change="isGreaterThanNinety" :title="$t('quantidade-de-registros-dentro-da-especificacao')"
            class="input-pentagro" id="progression" type="number" name="progression" v-model="progress" min="1"
            max="90" />
        </b-col>

        <b-col sm="3" class="workOrderocurrence mt-3" v-if="enableWorkOrder">
          <label for="workOrderocurrence" class="labelWorkOrderocurrence">{{ $t('ordem-de-servico') }}:</label>
          <span>
            <input :title="$t('ordem-de-servico')" class="ml-2 input-pentagro" id="workOrderocurrence" type="text"
              name="workOrderocurrence" v-model="workOrderOccurrence" />
          </span>
        </b-col>
      </b-row>
    </b-container>
    <!-- / DATA E UNIDADE -->

    <span v-if="!wait">
      <span v-if="this.indicatorList.length == 1">
        <p>{{ $t('aguardando-o-online-ficar-pronto-para-carregar-as-configuracoes') }}</p>
      </span>
      <!-- INDICADORES -->
      <div v-else class="indicatorList-list">
        <label for="indicatorList-select">{{ $t('indicadores-1') }}</label>
        <SearchableSelect
          class="form-control input-pentagro"
          :modelRef="indicatorKey"
          :optList="indicatorOptions"
          optValue="value"
          optDisplay="text"
          :inputFunc="handleIndicatorSelect"
          placeholder="Selecione um indicador"
        />
      </div>
      <!-- / INDICADORES -->

      <!-- RESPONSAVEIS -->
      <div class="responsible-list mt-3">
        <label for="responsible-select">{{ $t('responsaveis') }}</label>
        <SearchableSelect
          class="form-control input-pentagro"
          :modelRef="responsibleKey"
          :optList="responsibleOptions"
          optValue="value"
          optDisplay="text"
          :disabled="!productionUnit"
          :inputFunc="handleResponsibleSelect"
          placeholder="Selecione um responsável"
        />
      </div>
      <!-- / RESPONSAVEIS -->

      <!-- EQUIPAMENTO, PROCESSO E PRODUTO -->
      <SelectOrigin v-if="user.role == 'PGDI'" class="mt-3"
        :selected="{ processId: this.processId, processName: this.processName, equipmentId: this.equipmentId, equipmentName: this.equipmentName, productId: this.productId, productName: this.productName }"
        :editable="true" @selectedProcess="handleProcessSelected" @selectedEquipment="equipmentId = $event"
        @selectedProduct="productId = $event" @selectedProcessName="processName = $event"
        @selectedEquipmentName="equipmentName = $event" @selectedProductName="productName = $event" />
      <!-- / EQUIPAMENTO, PROCESSO E PRODUTO -->

    
      <button v-if="canHandleOccurrence == true" @click="openFaultTreeModal" class="add-reason-button">
          <span>{{ $t('add-reason') }}</span>
          <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
      </button>

      <div class="reasonTitle">
          <p>{{ $t('reason-and-action') }}</p>
      </div>

      <div v-if="reasonList.length > 0" class="reasonActionContainer">
          <details v-for="(reason, idx) in reasonList" :key="`reason-${idx}-${Math.random()}`">
              <summary>
                  <span class="reason-text">{{ reason.title }}</span>
                  <div class="reason-actions">
                      
                      <button v-if="canHandleOccurrence == true" 
                          @click.stop="removeReason(idx)" 
                          class="removeReasonBtn"
                          :title="$t('remove-reason')">
                          <b-icon-trash-fill />
                      </button>
                  </div>
              </summary>
              <article>
                  <div class="actionsContainer" v-if="reason.actions.length > 0">
                      <div v-for="(action, acIdx) in reason.actions" :key="`actions-${acIdx}-${Math.random()}`">
                          <div class="actionItem">
                              <div class="actionTitle">
                                  <strong>{{ $t('actionTableActionHeader') }}:</strong>
                                  <span :title="action.action">{{ action.action }}</span>
                              </div>
                              <div>
                                  <strong>{{ $t('actionTableResponsibleHeader') }}:</strong>
                                  <span :title="action.responsableName">{{ action.responsableName }}</span>
                              </div>
                              <div v-if="action.status == null || !action.status.toLowerCase().includes('concluída')">
                                  <strong>{{ $t('actionTableDeadlineHeader') }}:</strong>
                                  <span>{{ action.date }}</span>
                              </div>
                              <div v-else>
                                  <strong>{{ $t('conclusion') }}:</strong>
                                  <span>{{ action.closingDate.split('-')[0].trim() }}</span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <p class="voidActions" v-else>{{ $t('no-action-on-reason') }}</p>
                  
                  <button v-if="canHandleOccurrence == true" 
                      v-b-modal="'selectActionTree-' + idx"
                      class="add-action-btn"
                      :title="$t('add-action')">
                      <span>{{ $t('addActionButtom') }}</span>
                      <b-icon-plus-circle-fill />
                  </button>
              </article>
          </details>
      </div>
      <p v-else class="no-reason-found">{{ $t('no-reason-found') }}</p>

      <!-- OBSERVAÇÕES E LIÇÕES APRENDIDAS -->
      <div class="notes-container">
          <div class="notes-item">
              <span>{{ $t('occurrenceDetailsNotes') }}</span>
              <textarea id="occObservation" cols="35" rows="2" v-model="observation"></textarea>
          </div>
          <div class="notes-item">
              <span>{{ $t('occurrenceDetailsLessonsLearned') }}</span>
              <textarea id="occLessionLearned" cols="35" rows="2" v-model="lessonsLearned"></textarea>
          </div>
      </div>
      <!-- OBSERVAÇÕES E LIÇÕES APRENDIDAS -->
    </span>

    <!-- FAULTTREE -->
    <b-modal id="faultTreeSelect" size="lg" hide-footer :title="$t('selectReasonModal')" :no-close-on-backdrop="true">
      <FaultTreeSelect 
        @result="applyReaseon" 
        ref="faultTreeSelect"
      ></FaultTreeSelect>
    </b-modal>
    <!--/ FAULTTREE -->

    <!-- BOTÕES DA BASE -->
    <hr>
    <b-row class="groupBtn">
      <div v-if="messageToFinishOcc && messageToFinishOcc.length > 0" class="status-message mt-3">
        <span>{{ messageToFinishOcc }}</span>
      </div>
      <div>
        <img v-if="!hideSave" src="@/assets/salvar.png" :alt="$t('salvar')" style="margin-left: 30px;"
          :title="$t('salvar')" @click="canSaveOccurrence && save()" :class="{ 'disabled-button': !canSaveOccurrence }" />
        <img src="@/assets/atualizar.png" style="margin-left: 30px;" :title="$t('limpar')" :alt="$t('limpar')"
          @click="cleanFields" />
        <img id="closeModalPassword" class="float-right" src="@/assets/sair.png" style="margin-left: 30px;"
          :title="$t('cancelar')" :alt="$t('cancelar')" @click="() => {
            $bvModal.hide('newOccurenceByTrend');
            $bvModal.hide('newOccurence');
          }" />
      </div>
    </b-row>
    <!--/ BOTÕES DA BASE -->

    <b-modal id="confirmDuplicateOccurrence" size="md" hide-footer :title="$t('alerta')" :no-close-on-backdrop="true">
      <MessageBox :info="$t('ja-existe-uma-ocorrencia-aberta-com-este-mesmo-motivo-e-indicador')"
        modelname="confirmDuplicateOccurrence" :title="$t('atention')" />
    </b-modal>

    <!-- MODAL DE SELEÇÃO DE AÇÕES -->
    <b-modal v-for="(reason, idx) in reasonList" 
        :key="`modal-${idx}`"
        :id="`selectActionTree-${idx}`" 
        size="lg" 
        hide-footer 
        :title="$t('selectActionModal')" 
        :no-close-on-backdrop="true">
        <ActionsToSelect 
            :actionObj="{}"
            :indicatorId="indicatorId"
            :userObj="user"
            :reasonTreeId="reason.reasonTreeId"
            :reasonId="reason.id"
            :addActionFunction="(action) => addAction(action, idx)"
            :responsiblesList="responsibleList"
            :showActionResponsible="true"
            :needDeadline="true"
            :modalId="`selectActionTree-${idx}`"
        />
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { urlMainAPI, defaultSuccess, showError, emitEventBuss } from "@/global";
import { OccurrenceMixin } from "./occurrenceMixin"
import * as moment from "moment";
import FaultTreeSelect from "../faultTreeSelect/FaultTreeSelect.vue";
import { FiltersMixin } from "../mixins/filtersMixin";
import { WaitMixin } from "../mixins/waitMixin";
import MessageBox from "@/components/template/MessageBoxModal.vue";
import SelectOrigin from "./selectOrigin.vue";
import SearchableSelect from "../rta/commons/SearchableSelect.vue";
import axios from "axios";
import ActionsToSelect from "../manageAllOccurrences/utils/ActionsToSelect.vue";

export default {
  name: "newOccurence",
  computed: {
    ...mapState(["user"]),
    indicatorOptions() {
      return (this.filteredIndicators || []).map(ind => ({
        value: `${ind.indicatorId}-${ind.productionUnitId}-${ind.system}`,
        text: ind.indicatorName
      }));
    },
    responsibleOptions() {
      return (this.responsibleList || []).map(r => ({
        value: `${r.id}-${r.unitId}-${r.system}`,
        text: r.name
      }));
    }
  },

  props: ["keyByTrend"],

  components: {
    FaultTreeSelect,
    SelectOrigin,
    MessageBox,
    ActionsToSelect,
    SearchableSelect
  },

  mixins: [OccurrenceMixin, FiltersMixin, WaitMixin],

  data() {
    return {
      productionDate: moment().format('DD/MM/YYYY'),
      deadlineDate: moment().format('DD/MM/YYYY'),
      productionDat: null,
      indicatorList: [],
      indicatorKey: null,
      productionUnit: null,
      hideSave: false,
      filteredEquipments: [],
      configuration: {
        equipment: []
      },
      indicatorByTrend: {
        indicatorId: "",
        productionUnitId: "",
        system: ""
      },
      workeOrder: null,
      canHandleOccurrence: true,
      reasonList: [],
      observation: "",
      lessonsLearned: "",
      responsibleKey: null,
      responsibleId: -1,
      responsibleUnitId: null,
      system: null,
      processId: null,
      processName: null,
      equipmentId: null,
      equipmentName: null,
      productId: null,
      productName: null,
      messageToFinishOcc: "",
      canSaveOccurrence: true,
      optionsDatePicker: {
        maxDate: moment().format('YYYY-MM-DD'),
        format: 'DD/MM/YYYY',
        locale: 'pt-br'
      },
      optionsDeadlinePicker: {
        format: 'DD/MM/YYYY',
        locale: 'pt-br'
      }
    }
  },

  watch: {
    occurrenceDescription(value) {
      if (value.includes("Manutenção") && this.workeOrder)
        this.enableWorkOrder = true;
      else
        this.enableWorkOrder = false;
    },
    processId(newVal) {
      if (newVal) {
        this.filterEquipmentsByProcess(newVal);
      } else {
        this.filteredEquipments = [];
      }
    }
  },

  methods: {
    handleIndicatorSelect(event) {
      this.indicatorKey = event.target.value;
      this.setIndicatorId();
    },
    handleResponsibleSelect(event) {
      this.responsibleKey = event.target.value;
      this.setResponsible();
    },
    checkCanFinish() {
      if (!this.reasonList || this.reasonList.length === 0) {
        this.messageToFinishOcc = this.$t('no-reason-found');
        this.canSaveOccurrence = false;
        return false;
      }

      for (const reason of this.reasonList) {
        if (!reason.actions || !Array.isArray(reason.actions) || reason.actions.length === 0) {
          this.messageToFinishOcc = this.$t('existem-motivos-sem-acoes-cadastradas');
          this.canSaveOccurrence = false;
          return false;
        }
      }

      this.messageToFinishOcc = "";
      this.canSaveOccurrence = true;
      return true;
    },

    async save() {
      if (!this.indicatorId || this.indicatorId <= 0) {
        showError(this.$t('selecione-um-indicador-para-salvar-a-ocorrencia'));
        return;
      }

      if (!this.responsibleId || this.responsibleId === -1) {
        showError(this.$t('selecione-um-responsavel-para-salvar-a-ocorrencia'));
        return;
      }

      if (this.user.onlineType == 'PGDI' && !this.processId) {
        showError(this.$t('selecione-um-processo-1'));
        return;
      }

      if (!this.checkCanFinish()) {
        showError(this.messageToFinishOcc);
        return;
      }

      if (this.enableWorkOrder && !this.workOrderOccurrence) {
        showError(this.$t('campo-ordem-de-servico-e-obrigatorio'));
        return;
      }

      try {
        this.hideSave = true;
        defaultSuccess(this.$t('salvando-ocorrencia'));

        if (!await this.saveOccurrence()) {
          this.hideSave = false;
          return;
        }

        if (this.canSave) {
          emitEventBuss("reloadGridOccurrence")
          this.$bvModal.hide('newOccurence')
        }
        this.hideSave = false;
      } catch (error) {
        this.hideSave = false;
        showError(this.$t('ocorrencia-salva-falha'));
      }
    },

    async getIndicatorList() {
      const url = `${urlMainAPI}/getindicatorlist`;
      await axios.get(url).then((res) => {
        if (res.status === 200) {
          const uniqueIndicators = res.data.filter((indicator, index, self) =>
            index === self.findIndex((i) => i.indicatorId === indicator.indicatorId)
          );

          this.indicatorList = uniqueIndicators;
        } else {
          showError(this.$t('o-online-ainda-nao-esta-pronto'));
        }

        this.wait = false;
      }).catch(e => {
        console.log(e);
        showError(this.$t('o-online-ainda-nao-esta-pronto-tente-novamente-quando-o-oline-estiver-pronto'));
        this.$bvModal.hide('newOccurence');
      });
    },

    async filterEquipmentsByProcess(processId) {
      if (!processId) {
        this.filteredEquipments = [];
        return;
      }
      
      try {
        const url = `${urlMainAPI}/getequipments`;
        const res = await axios.get(url);
        if (res.data) {
          this.filteredEquipments = res.data.filter(equipment => 
            equipment.processId === processId
          );
        }
      } catch (err) {
        console.error("Erro ao filtrar equipamentos:", err);
        this.filteredEquipments = [];
      }
    },

    handleProcessSelected(selected) {
      let pid;
      
      if (typeof selected === 'object') {
        pid = Number(selected.processId || selected.id);
      } else {
        pid = Number(selected);
      }
      
      if (isNaN(pid)) {
        console.error('ProcessId inválido:', selected);
        return;
      }
      
      this.processId = pid;
      this.filterEquipmentsByProcess(pid);
    },

    indicatorsFilter() {
      let unitId = parseInt(this.user.UnitId)
      this.filteredIndicators = this.indicatorList.filter(i => i.productionUnitId == unitId)
        .sort((a, b) => a.indicatorName > b.indicatorName ? 1 : (a.indicatorName < b.indicatorName) ? -1 : 0)
    },

    resetForm() {
      this.indicatorKey = null;
      this.responsibleKey = null;
    },

    setIndicatorId() {
      if (this.indicatorKey == null)
        return;

      let key = this.indicatorKey.split("-");
      this.indicatorId = key.length == 3 ? parseInt(key[0]) : -9999;
      
      if (this.$refs.faultTreeSelect) {
        const [id, productionUnitId, system] = key;
        this.$refs.faultTreeSelect.setFaulTree({
          id: parseInt(id),
          productionUnitId: parseInt(productionUnitId),
          system: system
        });
      }
    },

    async loadFields() {
      const url = `${urlMainAPI}/getindicatorlist`;
      await axios.get(url).then(async (res) => {
        if (res.data) {
          await res.data.forEach(i => {
            if (i.key == this.keyByTrend) {
              this.indicatorByTrend.id = i.indicatorId;
              this.indicatorByTrend.productionUnitId = i.productionUnitId;
              this.indicatorByTrend.system = i.system;
            }
          })
          this.setFields();
        }
      }).catch(console.log);
    },

    async setFields() {
      this.productionUnit = await this.productionsUnitList.find(u => u.id == this.indicatorByTrend.productionUnitId)
      this.indicatorKey = `${this.indicatorByTrend.id}-${this.indicatorByTrend.productionUnitId}-${this.indicatorByTrend.system}`
      this.indicatorId = this.indicatorByTrend.id;
    },

    setDate() {
      const today = moment();
      this.productionDate = today.format('DD/MM/YYYY');
    },

    async getWorOrderInOccurrence() {
      const url = `${urlMainAPI}/getsystemconfiguration`;
      await axios.get(url)
        .then((res) => {
          this.workeOrder = res.data.workOrderInOccurrence
        })
        .catch();
    },

    async removeReason(idx) {
      this.reasonList.splice(idx, 1);
      this.checkCanFinish();
    },

    async applyReaseon(result) {
      if (!result || !result.path) return;

      const newReason = {
        title: result.path,
        id: result.node.id,
        reasonTreeId: result.node.id,
        createdBy: this.user.Id,
        hasOtherDesc: result.node.data.text.toLowerCase() == 'outros' || 
                    result.node.data.text.toLowerCase() == 'outro' || 
                    result.node.data.text.toLowerCase().includes('outro'),
        reasonOtherDescription: '',
        actions: []
      };

      this.reasonList.push(newReason);
      this.$bvModal.hide('faultTreeSelect');
      this.checkCanFinish();
    },

    async clearActions() {
      if (!this.reasonList.length) return;
      
      const lastReason = this.reasonList[this.reasonList.length - 1];
      lastReason.actions = [];
    },

    async saveOccurrence() {
      if (!this.reasonList.length) {
        showError(this.$t('adicione-motivo'));
        return false;
      }

      try {
        if (!this.productionDate) {
          this.productionDate = moment().format('DD/MM/YYYY');
        }
        
        const [day, month, year] = this.productionDate.split('/');
        const now = moment();
        const currentDate = moment(`${year}-${month}-${day} ${now.format('HH:mm:ss')}`, 'YYYY-MM-DD HH:mm:ss');
        
        if (currentDate.isAfter(moment())) {
          showError(this.$t('ocorrencias-com-data-futura'));
          return false;
        }
        
        const formattedDate = currentDate.format('YYYY-MM-DD HH:mm:ss');
        
        const urlWorkshift = `${urlMainAPI}/getworkshift`;
        const workshiftResponse = await axios.get(urlWorkshift);
        
        let workshiftId = 0;
        if (workshiftResponse && workshiftResponse.data) {
          const workshifts = workshiftResponse.data;
          const currentTime = formattedDate.split(' ')[1];
          
          for (const ws of workshifts) {
            if (ws.id === 4) continue;
            
            const startTime = ws.startTime.split('.')[0];
            const endTime = ws.endTime.split('.')[0];
            
            if (endTime < startTime) {
              if ((currentTime >= startTime && currentTime <= "23:59:59") || 
                  (currentTime >= "00:00:00" && currentTime < endTime)) {
                workshiftId = ws.id;
                break;
              }
            } else {
              if (currentTime >= startTime && currentTime < endTime) {
                workshiftId = ws.id;
                break;
              }
            }
          }
        }

        let newDescription = "";
        let newActionArr = [];

        this.reasonList.forEach(item => {
          item.actions.forEach(ac => delete ac.responsableName);
          newActionArr.push(...item.actions);
          newDescription += `${item.title};`;
        });

        const occurrenceData = {
          id: 0,
          productionUnitId: parseInt(this.user.UnitId),
          system: this.user.onlineType[0],
          description: newDescription,
          baseDate: formattedDate,
          phaseId: 1,
          deadline: this.deadlineDate,
          profileId: 3,
          responsibleId: this.responsibleId,
          responsibleUnitId: this.responsibleUnitId,
          statusId: 1,
          workshift: workshiftId,
          documentContent: null,
          replanned: false,
          replannedBy: null,
          indicatorId: [this.indicatorId],
          observation: this.observation,
          content: JSON.stringify({
            actionsList: newActionArr,
            lessonsLearned: this.lessonsLearned,
            workOrder: this.workOrderOccurrence,
            processId: this.processId || 0,
            processName: this.processName || "Não informado",
            equipmentId: this.equipmentId || 0,
            equipmentName: this.equipmentName || "Não informado",
            productId: this.productId || 0,
            productName: this.productName || "Não informado"
          }),
          reasonContent: JSON.stringify({
            reasons: this.reasonList,
            occurrenceHandleBy: {
              id: this.user.Id,
              name: this.user.FullName,
              email: "",
              receiveAutonomousWarning: false,
              system: this.user.onlineType[0],
              unitId: this.user.UnitId
            }
          })
        };

        const url = `${urlMainAPI}/saveoccurrence`;
        const response = await axios.post(url, occurrenceData);
        
        if (response.status === 200) {
          defaultSuccess(response.data);
          this.$bvModal.hide('newOccurence');
          return true;
        }
      } catch (error) {
        showError(error.response?.data || 'Erro ao salvar ocorrência');
        return false;
      }
    },

    async setResponsible() {
      if (!this.responsibleKey) {
        [this.responsibleId, this.responsibleUnitId, this.system] = [-1, null, null];
        return;
      }

      [this.responsibleId, this.responsibleUnitId, this.system] = this.responsibleKey.split('-').map((val, i) => i < 2 ? parseInt(val) : val);
    },

    async addAction(action, idx) {
      if (!this.reasonList[idx]) return;
      
      this.reasonList[idx].actions = this.reasonList[idx].actions || [];
      this.reasonList[idx].actions.push(action);
      this.$bvModal.hide('selectActionTree-' + idx);
      this.checkCanFinish();
    },

    validateDate(date) {
      if (!date) return;
      
      const selectedDate = moment(date, 'DD/MM/YYYY');
      const currentDate = moment().startOf('day');
      
      if (selectedDate.isAfter(currentDate)) {
        showError(this.$t('ocorrencias-com-data-futura'));
        this.productionDate = currentDate.format('DD/MM/YYYY');
      }
    },

    validateDeadlineDate(date) {
      if (!date) return;
      this.deadlineDate = date;
    },

    openFaultTreeModal() {
      this.$bvModal.show('faultTreeSelect');
      
      // Aguardar o próximo ciclo para garantir que o componente foi montado
      this.$nextTick(() => {
        if (this.indicatorKey && this.$refs.faultTreeSelect) {
          const key = this.indicatorKey.split("-");
          if (key.length === 3) {
            this.$refs.faultTreeSelect.setFaulTree({
              id: parseInt(key[0]),
              productionUnitId: parseInt(key[1]),
              system: key[2]
            });
          }
        }
      });
    },

    addActionToList(actionToAdd, reasonId) {
      this.reasonList.forEach(item => {
        if (item.id == reasonId) {
          if (!item.actions) {
            item.actions = [];
          }
          let actionFound = item.actions.findIndex(ac => ac.id == actionToAdd.actionId || ac.actionId == actionToAdd.actionId);

          if (actionFound == -1) {
            item.actions.push(actionToAdd);
          } else {
            item.actions.splice(actionFound, 1, actionToAdd);
          }
        }
      });

      const allHaveActions = this.reasonList.every(reason => 
        reason.actions && Array.isArray(reason.actions) && reason.actions.length > 0
      );

      if (allHaveActions) {
        this.messageToFinishOcc = "";
      }

      if (reasonId) {
        this.$bvModal.hide('selectActionTree-' + reasonId);
      }
    },

    openActionModal(reason, action) {
      if (action != null) {
        this.editingAction = action;
      }

      this.currentReasonId = reason.id;
      this.currentReasonTreeId = reason.reasonTreeId;
      this.$bvModal.show("selectActionTree-" + reason.id);
    },
  },

  async created() {
    this.setDate()
    await this.getWorOrderInOccurrence();
    await this.loadResponsibleList();
    await this.getIndicatorList();
    this.indicatorsFilter();
    if (this.keyByTrend) this.loadFields();
    this.checkCanFinish();
  },

  destroyed() { this.wait = false },
}
</script>

<style scoped src=".\occurrence.css"></style>
<style scoped>
.row {
  gap: 10px;
}

.body {
  margin: 8px;
}

.label-desc {
  margin-right: 17px
}

.textarea {
  border: 2px solid #505050;
}

.occurrence-config {
  border-radius: 4px;
  box-shadow: 1px 1px 2px 1px #00000030;
  padding: 8px;
  margin-bottom: 5px;
}

.reason-button {
  margin-left: 10px;
  width: 100px;
  border: 1px solid;
  color: white;
  background-color: #ff5f00;
  border-radius: 8px;
  font-weight: 500;
}

.date-item-2 {
  display: flex;
  align-items: center;
  justify-items: flex-start;
  width: 100%;
  min-width: 135px;
}

.unit-production-config label,
.date-item label {
  min-width: 140px;
  max-width: 300px;
}

.deadline-config {
  align-items: center;
}

.deadline-config label {
  min-width: 140px;
  max-width: 300px;
  margin-bottom: 0;
  white-space: nowrap;
  margin-right: 17px;
}

.deadline-config .date-item-2 {
  display: flex;
  align-items: center;
  justify-items: flex-start;
  width: 100%;
  min-width: 135px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.groupBtn img {
  cursor: pointer;
  max-height: 35px;
}

.workOrderocurrence {
  margin-left: -80px;
  display: flex;
  align-items: center;
}

.workOrderocurrence label {
  min-width: 130px;
}

.workOrderocurrence input {
  margin-top: -10px;
}

@media only screen and (max-width: 1199px) {
  .date-item,
  .unit-production-config,
  .deadline-config,
  .progression-config {
    max-width: none;
    flex: none;
  }

  .occurrence-date {
    height: 125px;
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: 70% 30%;
  }

  .deadline-config {
    grid-column-start: 1;
  }

  .progression-config {
    grid-column-start: 2;
  }

  .workOrderocurrence {
    grid-column-start: 2;
    grid-row-start: 1;
    margin-left: 0px
  }
}

@media only screen and (max-width: 991px) {
  .occurrence-date {
    flex-direction: column;
    align-items: stretch;
  }

  .date-item,
  .progression-config {
    width: 100%;
  }
}

@media only screen and (max-width: 771px) {
  .date-item {
    grid-row-start: 1 span;
    grid-column-start: 1;
    min-width: 257px;
    max-width: 450px;
  }

  .unit-production-config {
    grid-column-start: 1;
    grid-row-start: 2;
    min-width: 257px;
    max-width: 422px;
  }

  .deadline-config {
    grid-row-start: 3;
    grid-column: 1;
    margin-left: 0%;
    max-width: 50%;
    align-items: baseline;
  }

  .progression-config {
    grid-row-start: 3;
    grid-column: 1;
    margin-left: 50%;
    max-width: 50%;
    min-width: 192px;
  }
}

@media only screen and (max-width: 530px) {
  .unit-production-config label {
    margin-right: -4px;
  }
}

@media only screen and (max-width: 434px) {
  .occurrence-config {
    height: 290px;
  }

  .date-item,
  .progression-config {
    flex-direction: column;
    gap: 5px;
  }

  .date-item label,
  .progression-config label {
    margin-bottom: 5px;
  }

  .workOrderocurrence>span>input {
    width: 150px;
  }
}

.reasonTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.4rem 0;
    font-weight: bold;
}

.reasonTitle p {
    font-weight: bold;
    margin: 0;
    font-size: 1.1rem;
}

.reasonTitle button,
article button {
    background-color: #ff5f00;
    color: white;
    font-weight: bold;
    border: 1px solid #ff5f00;
    border-radius: 0.2rem;
    font-size: 1rem;

    display: flex;
    align-items: center;
    column-gap: 0.4rem;
}

article {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    border: 1px solid gray;
    padding: 0.1rem;
}

article button {
    align-self: center;
    justify-self: center;
}

.reasonTitle button svg,
article button svg {
    color: #006F6F;
    stroke: white;
}

.notes-container {
    display: flex;
    gap: 20px;
    margin: 20px 0;
}

.notes-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.notes-item span {
    font-weight: bold;
}

.notes-item textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    resize: vertical;
}

@media only screen and (max-width: 771px) {
    .notes-container {
        flex-direction: column;
    }
}

.no-reason-found {
    opacity: 0.5;
}

.reason-text {
    font-weight: 500;
    background-color: #000;
    color: white;
    padding: 0.2rem 0.4rem;
    margin: 0.5rem 0;
}

.add-reason-button {
    background-color: #ff5f00;
    color: white;
    font-weight: bold;
    border: 1px solid #ff5f00;
    border-radius: 0.2rem;
    font-size: 1rem;
    display: flex;
    align-items: center;
    column-gap: 0.4rem;
    padding: 0.2rem 0.4rem;
    margin-bottom: 0.4rem;
    margin-left: auto;
}

.add-reason-button svg {
    color: #006F6F;
    stroke: white;
}

.reasonActionContainer {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
}

details {
    margin-bottom: 10px;
}

summary {
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem 0.4rem;
    font-weight: bold;
    background-color: black;
    color: white;
    position: relative;
    column-gap: 1rem;
}

summary::after {
    content: "Visualizar Ações \02C3";
    transition: 0.2s;
    font-size: 0.9rem;
    background-color: #ff5f00;
    color: #fff;
    border-radius: 0.2rem;
    padding: 0.1rem 0.6rem;
}

details[open] summary::after {
    content: "Visualizar Ações \02C5";
    transition: 0.2s;
    font-size: 0.9rem;
    background-color: #ff5f00;
    color: #fff;
    border-radius: 0.2rem;
    padding: 0.1rem 0.6rem;
}

summary span {
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
}

.reason-text {
    color: white;
    font-weight: 500;
    margin: 0;
}

.reason-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-left: auto;
}

.removeReasonBtn {
    display: block;
    font-size: 0.9rem;
    font-weight: bold;
    background-color: #FF1F1F;
    border: none;
    border-radius: 0.2rem;
    color: white;
    cursor: pointer;
    padding: 0.2rem 0.4rem;
}

.actionsContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
}

.actionsContainer section {
    width: 100%;
}

.actionItem {
    width: 100%;
    border-bottom: 1px solid gray;
    display: grid;
    grid-template-columns: 3fr 2fr 1fr 1fr;
    align-items: center;
    padding: 0.1rem 0.2rem;
    column-gap: 0.5rem;
}

.actionItem strong {
    font-weight: bold;
    color: #ff5f00;
    margin-right: 0.2rem;
    font-size: 0.9;
}

.actionItem span {
    font-weight: normal;
    font-size: 0.9rem;
    color: rgb(59, 59, 59);
}

.actionItem .actionTitle {
    max-width: 95%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
}

.voidActions {
    margin: 0;
    padding: 0 0.2rem;
    text-align: left;
    width: 100%;
    border-bottom: 1px solid gray;
}

.add-action-btn {
    margin: 0.2rem 0;
    background-color: #ff5f00;
    color: white;
    font-weight: bold;
    border: 1px solid #ff5f00;
    border-radius: 0.2rem;
    font-size: 1rem;
    display: flex;
    align-items: center;
    column-gap: 0.4rem;
    padding: 0.2rem 0.4rem;
}

.add-action-btn svg {
    color: #006F6F;
    stroke: white;
}

.status-message {
    color: #ff5f00;
    display: flex;
    align-items: center;
    margin-right: auto;
}

.status-message svg {
    font-size: 1.2em;
    margin-right: 8px;
}

.status-message span {
    font-weight: 500;
}

.disabled-button {
  opacity: 0.5;
  cursor: not-allowed;
  filter: grayscale(100%);
  pointer-events: none;
}

.progression-config {
  display: flex;
  align-items: center;
}

.progression-config label {
  min-width: 140px;
  max-width: 300px;
  margin-right: 17px;
  white-space: nowrap;
}

.progression-config input {
  width: 100%;
  min-width: 135px;
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

@media only screen and (max-width: 434px) {
  .progression-config {
    display: block !important;
  }
  
  .progression-config label {
    display: block;
    margin-bottom: 0.5rem;
  }
}
</style>
